import React from 'react'
import { buildHoverTooltipAnchorProps } from 'components/shared/tooltipContract'
import { isMobile } from 'lib/device'

/**
 * @typedef {{
 *   tip?: string,
 *   children?: React.ReactNode,
 *   offset?: number,
 * }} CopyTooltipProps
 */

export default React.forwardRef(function CopyTooltip(
    /** @type {CopyTooltipProps} */ { tip, children, offset },
    ref,
) {
    const anchorProps = buildHoverTooltipAnchorProps(
        { content: tip, place: 'bottom', offset: offset || 0 },
        { touchLayout: isMobile },
    )

    return (
        <div
            ref={ref}
            className="with-tool-tip-comp comp"
            {...anchorProps}
            style={{ display: 'inline-block' }}
        >
            {children}
        </div>
    )
})
